"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamTAGTypography = void 0;
var common = __importStar(require("../../shared/typography"));
exports.teamTAGTypography = [
    common.header3,
    common.header4,
    common.bodyXLBook,
    common.bodyLargeBook,
    common.bodyLargeBold,
    common.bodyLargeSemiBold,
    common.bodyMediumSemiBold,
    common.bodySmallBook,
    common.bodySmallBold,
    common.bodySmallSemiBold,
    common.overline,
    common.notification,
    common.errorValidation,
    {
        props: common.header1.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header1Common), { fontFamily: 'DIN 2014 Narrow W05 Extra Light', fontWeight: 250, fontSize: '4rem', lineHeight: '5rem', letterSpacing: '-1px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
        },
    },
    {
        props: common.header2.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header2Common), { fontFamily: 'DIN 2014 Narrow W05 Demi', fontWeight: 700, letterSpacing: '2px', fontSize: '1.375rem', lineHeight: '1.75rem', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '1rem',
                    lineHeight: '1.5rem',
                } }));
        },
    },
    {
        props: common.bodyMediumBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyMediumBookCommon), { fontFamily: 'Messina Modern', fontWeight: 400, color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:720px)': {
                    fontSize: '1.125rem',
                    lineHeight: '1.75rem',
                } }));
        },
    },
    {
        props: common.bodyMediumBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyMediumBoldCommon), { fontFamily: 'DIN 2014 Narrow W10 Demi', letterSpacing: '2px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }));
        },
    },
    {
        props: common.captionLarge.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.captionLargeCommon), { fontWeight: 400, color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.captionMedium.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.captionMediumCommon), { fontWeight: 400, color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.lowestLevelBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.lowestLevelBookCommon), { fontWeight: 400, letterSpacing: '0px', color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
];
